import { ComponentProps } from 'react'
import { makeStyles } from '@material-ui/core'

import { joinStyles } from 'app/utils/theme'

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
})

type FormProperties = ComponentProps<'form'>

export const Form = ({
    className,
    ...properties
}: Readonly<FormProperties>): JSX.Element => {
    const classes = useStyles()

    return (
        <form
            className={joinStyles(classes.root, className)}
            {...properties}
        />
    )
}
